import { Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, tap, take } from 'rxjs/operators';
import { map, catchError } from 'rxjs/operators';

import * as fromActions from '../actions/sports.actions';
import * as fromSelectors from '../selectors/sports.selectors';

import { DT } from 'src/app/core/helpers/date-time.helper';
import { SportsService } from 'src/app/features/sports/services/sports.service';
import { SportsState } from '../../models/rootState.model';
import { Action_Sport_Init } from '../actions/sport-active.actions';
import { UtilService } from '../../services/util.service';


@Injectable()
export class SportsEffects {

  constructor(
    private actions$: Actions,
    private service: SportsService,
    private store: Store<any>,
    private util: UtilService

  ) { }


  @Effect()
  loadSports$: Observable<Action> = this.actions$.pipe(
    ofType(fromActions.SPORT_ACTIONS.LOAD_SPORTS),
    switchMap(() => this.store.select(fromSelectors.selectSportsState).pipe(
      take(1),
      switchMap(currentData => {
        // fetch new data from API
        return this.service.getSports({ acceptCache: '90d', cacheGroup: 'default' }).pipe(
          map((response) => {
            return new fromActions.Action_Sports_Load_Success(response.payload);
          }),
          catchError(err => {

            this.util.error.go({
              buttonText: 'Voltar',
              code: '1x2048e120',
              message: `Não foi possível carregar a lista de esportes de nossos servidores.
                            <br/>Tente novamente em alguns instantes.`,
              autoexecute: 30
            }, false);
            return of(new fromActions.Action_Sports_Load_Fail(err));
          })
        );
      }),
      tap((action) => {
        // after load the sports, auto start the current sport state
        this.store.dispatch(new Action_Sport_Init());

      })
    ))
  );
}
